// removed by extract-text-webpack-plugin
module.exports = {"detail":"FormTaskEmbed__detail___1Rfry","form":"FormTaskEmbed__form___1sV23","title":"FormTaskEmbed__title___1u2e8","firstRow":"FormTaskEmbed__firstRow___15W2j","buttonRow":"FormTaskEmbed__buttonRow___y8Cvm","meta":"FormTaskEmbed__meta___2Ch-_","noBorder":"FormTaskEmbed__noBorder___1kW63"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormTaskEmbed/FormTaskEmbed.scss
// module id = 1184
// module chunks = 1